import React from 'react';
import { Button as MuiButton } from '@mui/material';

const Button = ({ children, ...props }) => {
  return (
    <MuiButton variant={props.variant || "contained"} {...props}>
      {children}
    </MuiButton>
  );
};

export default Button;
